import React from 'react'

import {Grid, Row, Col} from 'react-flexbox-grid'

import {Button} from 'antd'

import {Link} from 'react-router'

import {Login, Register} from 'bundle/auth'
import {Notify} from 'ui'
import {AuthStore} from 'api/auth'

export class Index extends React.Component {
   static get propTypes() {
      return {
         location: React.PropTypes.object.isRequired
      }
   }

   constructor(props) {
      super(props)
      this._notify = null
   }

   componentWillMount() {
      this._notify = new Notify.Store()
   }

   render() {
      let {location} = this.props,
         {auth} = location.query

      console.log('render', 'pages/Index', window.location.hash)

      return (
         <div className="page index">
            <TopRow auth={auth} notify={this._notify} {...this.props} />

            <Grid>
               <MainFeatures />

               <GuidedTour />

            </Grid>
         </div>
      )
   }
}

let GuidedTour = () => (
   <Row style={{padding: '4rem 0 2rem'}}>
      <Col md={6}>
         <div className="text-center" style={{fontSize: '10em'}}>
            ICON
         </div>
      </Col>

      <Col md={6}>
         <h1>Getting started</h1>

         <p className="lead">
            Make any Tinymesh Gateway device available through the Tinymesh Cloud.
         </p>

         <p>
            Using <a href="https://release.tiny-mesh.com/tinymesh/guri">GURI</a> you
            can establish online connectivity with your Tinymesh Network in a few easy steps.{' '}
         </p>

         <p>
            You can use configure, read and write data through a browser or using the HTTP API.
         </p>

         <p className="">
            Get a Evaluation Kit Today by contacting your local distributor.
         </p>
      </Col>
   </Row>
)

const TopRow = props => {
   let auth = AuthStore.auth,
      {location} = props

   if (!auth) {
      return (
         <div className="featured">

            <Grid>
               <Row between="sm">
                  <Col sm={5}>
                     <IntroCopy
                        signupLink={{...location, query: {...location.query, auth: 'register'}}}
                     />
                  </Col>
                  <Col sm={6}>
                     <div
                        style={{
                           display: 'register' !== props.auth ? 'initial' : 'none'
                        }}
                     >
                        <Notify store={props.notify} />
                        <Login
                           redirect="/dashboard"
                           {...props}
                           signupLink={{...location, query: {...location.query, auth: 'register'}}}
                        />
                     </div>

                     <div
                        style={{
                           display: 'register' === props.auth ? 'initial' : 'none'
                        }}
                     >
                        <Notify store={props.notify} />
                        <Register
                           redirect="/dashboard"
                           {...props}
                           loginLink={{...location, query: {...location.query, auth: 'login'}}}
                        />
                     </div>
                  </Col>
               </Row>
            </Grid>
         </div>
      )
   } else {
      return (
         <div className="featured">

            <Grid>
               <Row>
                  <Col sm={6}><IntroCopy /></Col>
                  <Col sm={6}>
                     <h1>Welcome back</h1>

                     <Link to="/dashboard">
                        <Button>Go to dashboard</Button>
                     </Link>
                  </Col>
               </Row>
            </Grid>
         </div>
      )
   }
}

TopRow.propTypes = {
   auth:     React.PropTypes.string,
   notify:   React.PropTypes.object,
   location: React.PropTypes.object.isRequired
}

const IntroCopy = ({signupLink}) => (
   <div className="copy">
      <h1 style={{fontWeight: 'normal'}}>
         Sense, Monitor and Control <strong>any device</strong>
      </h1>

      <p className="body">
         Sense inputs, monitor alerts, or control outputs
         of your <strong>Tiny Mesh™</strong> device from anywhere in the world!
      </p>

      <p className="text-right">
         <Link to={signupLink}>
            <Button type="primary">Sign Up</Button>
         </Link>
         &nbsp;
         <a target="_new" href="https://tiny-mesh.com">
            Learn more at tiny-mesh.com
         </a>
      </p>
   </div>
)

IntroCopy.propTypes = {
   signupLink: React.PropTypes.object.isRequired
}

const MainFeatures = () => (
   <Row className="text-center features" style={{padding: '4rem 0 2rem'}}>
      <Col sm={4}>

         <h3>Read and write GPIO</h3>

         <p>
            GPIO Pins are easily observed or controlled through the Workbench.
            Information about the state can be read, or updated by a command.
         </p>
      </Col>

      <Col sm={4}>
         <h3>Connect Everywhere</h3>

         <p>
            Using Tinymesh Connector Software you can connect any Tinymesh Network
            to the Cloud from any computer.
         </p>
      </Col>

      <Col sm={4}>

         <h4>Over-the-air configuration</h4>

         <p>
            Configuration data is readily available along with the possibility to
            configure any parameter after field deployment.
         </p>
      </Col>
   </Row>
)



// WEBPACK FOOTER //
// lib/pages/Index.jsx